import React from 'react';
import SearchInput from 'components/common/forms/SearchInput';
import SingleBtn from 'components/common/elements/SingleBtn';
import { SearchFilterField } from 'types/form/searchFilter';

type TProps = {
  input: {
    placeholder: string;
    width: string;
  };
  handleSearchWord: () => void;
};

const SearchInputWithButton: React.FC<TProps> = ({
  input,
  handleSearchWord,
}) => {
  return (
    <>
      <SearchInput
        name={SearchFilterField.searchWord}
        inputWrapperStyle={{
          width: input.width,
          height: '40px',
        }}
        inputStyle={{
          border: '0',
          height: '38px',
          padding: '8px 0 8px 8px',
        }}
        placeholderText={input.placeholder}
        handleEnter={handleSearchWord}
      />
      <SingleBtn
        btnText="검색"
        isBtnActive={true}
        btnStyle={{
          padding: '8px 24px',
        }}
        onClick={handleSearchWord}
      />
    </>
  );
};

export default SearchInputWithButton;
